import React from 'react';
import {
    Content,
    ScreenshotContainer,
    ScreenshotImage,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge
} from './styles';
import { useTheme } from '../../hooks/useTheme';
import { appStoreURL } from '../../constants/urls';

const Home = () => {
    const isDarkMode = useTheme() === 'dark';

    return (
        <Content>
            <TextContainer>
                <Title>Stay Focused, Achieve More.</Title>
                <SubTitle>The clear and simple way to track your goals.</SubTitle>
                <Description>OnTrack is designed for simplicity. No clutter, no distractions, just a clear view of your progress. Whether you're tracking a project, savings, or personal milestones, OnTrack makes it effortless to see where you stand and get to the finish line. Experience the power of clarity today.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" /></a>
            </TextContainer>
            <ScreenshotContainer><ScreenshotImage src={`/assets/screenshot${isDarkMode ? '_dark' : ''}.png`} /></ScreenshotContainer>
        </Content>
    )
}

export default Home;
